import { AbstractItemModel, ItemType } from './abstract-item-model';

// tslint:disable-next-line: no-var-requires
const moment = require('moment');

export class GenericItem extends AbstractItemModel {
  public title: string;
  public subtitle: string;
  public description: string;
  public tags: string[];
  public url: string;
  public imageURL?: string;
  public type: string = ItemType.Generic.toString();
  public id: string;
  public timeAdded: Date;
  public listId: string;
  public listTitle: string;
  public authorId: string;
  public isListed: boolean;
  public isPublic: boolean;

  public makeDummy(): GenericItem {
    this.title = 'title';
    this.subtitle = 'subtitle';
    // @ts-ignore
    this.description = 'descriptio sdjflk jsdkglj sdlkgaj dkfhg kfjglks jglksdj flksdajf lkasdjf klsdjfkls jdafk;ljsa fkl;';
    this.url = 'http://cnn.com';
    this.timeAdded = moment().subtract(17, 'minute');
    return this;
  }

  public toFirebaseDoc(): any {
    return {
      title: this.title,
      subtitle: this.subtitle || null,
      description: this.description || null,
      tags: this.tags || [],
      url: this.url || null,
      type: this.type.toString(),
      imageURL: this.imageURL || null,
      id: this.id || null,
      timeAdded: this.timeAdded ? this.timeAdded.getTime() : new Date().getTime(),
      listId: this.listId || null,
      listTitle: this.listTitle || null,
      authorId: this.authorId || '',
      isListed: this.isListed || '',
      isPublic: this.isPublic || ''
    };
  }

  public fromFirebaseDoc(id: string, document: any): GenericItem {
    this.id = id;
    this.type = document.type as string;
    this.title = document.title as string;
    this.subtitle = document.subtitle as string;
    this.description = document.description as string;
    this.tags = document.tags as string[];
    this.url = document.url as string;
    this.imageURL = document.imageURL as string;
    this.timeAdded = new Date(document.timeAdded as number || 0);
    this.listId = document.listId as string;
    this.listTitle = document.listTitle as string;
    this.authorId = document.authorId as string;
    this.isListed = document.isListed as boolean;
    this.isPublic = document.isListed as boolean;
    return this;
  }
}
